/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.17.0
 * @since 1.0.1
 */

import { createSelector } from 'reselect';
import { OutputSelector } from 'reselect/src';

import { IRootReducer } from '../../reducers/rootReducer';
import { IHeaderReducer } from './headerReducer';

export const getAuthDataUser = (state: IRootReducer) =>
    state.header;

export const makeSelectorHelpFlag = (): OutputSelector<IRootReducer, boolean, (state: IHeaderReducer) => boolean> =>
    createSelector(
        getAuthDataUser,
        (state: IHeaderReducer) => state.helpFlag,
    );

export const makeSelectorHelpTipText = (): OutputSelector<IRootReducer, string, (state: IHeaderReducer) => string> =>
    createSelector(
        getAuthDataUser,
        (state: IHeaderReducer) => state.helpTipText || '',
    );
